module.exports = __webpack_public_path__ + "static/media/Success.5835bcf3.svg";